export const formatAction = (title) => {
  return title.replace("attack_", "").replace("rwp", "real_world_phishing")
}
